(function () {
  if (window.__mpnMenuTop) return; window.__mpnMenuTop = true;
  function place() {
    document.querySelectorAll('.menu-drawer .mpn-menu-all-top[data-mpn-pending]').forEach(function (a) {
      var panel = a.closest('.menu-drawer__submenu');
      if (!panel) return;
      var btn = null;
      for (var n = a.previousElementSibling; n; n = n.previousElementSibling) {
        if (n.classList && n.classList.contains('menu-drawer__close-button')) { btn = n; break; }
      }
      if (!btn) btn = panel.querySelector('.menu-drawer__close-button');
      if (!btn || btn.closest('.menu-drawer__submenu') !== panel) return;
      if (!btn.querySelector('.mpn-head-t')) {
        var txt = [];
        [].slice.call(btn.childNodes).forEach(function (c) { if (c.nodeType === 3 && c.textContent.trim()) txt.push(c); });
        if (txt.length) {
          var s = document.createElement('span');
          s.className = 'mpn-head-t';
          s.textContent = txt.map(function (t) { return t.textContent.trim(); }).join(' ');
          txt.forEach(function (t) { t.parentNode.removeChild(t); });
          btn.appendChild(s);
        }
      }
      var row = btn.parentElement;
      if (!row.classList.contains('mpn-head-row')) {
        row = document.createElement('div');
        row.className = 'mpn-head-row';
        btn.parentNode.insertBefore(row, btn);
        row.appendChild(btn);
      }
      row.appendChild(a);
      a.removeAttribute('data-mpn-pending');
    });
  }
  function repaint(panel) {
    if (!panel) return;
    [panel, panel.querySelector('.menu-drawer__inner-submenu')].forEach(function (el) {
      if (!el) return;
      el.scrollTop = 0;
      el.style.transform = 'translateZ(0)';
      void el.offsetHeight;
      requestAnimationFrame(function () { el.style.transform = ''; });
    });
  }
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d || !d.open || !d.closest || !d.closest('#menu-drawer')) return;
    place();
    var panel = d.querySelector(':scope > .menu-drawer__submenu');
    setTimeout(function () { repaint(panel); }, 60);
    setTimeout(function () { repaint(panel); }, 420);
  }, true);
  document.addEventListener('click', function () { setTimeout(place, 30); }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', place); else place();
})();
